import React from "react";
import { useI18nStore } from "../../stores/i18nStore";

interface Props {
  /** "€9" — the price as shown on the card above. */
  price: string;
  kind: "recurring" | "one_time";
  className?: string;
}

/**
 * What a purchase commits the buyer to, next to the button that makes it
 * (blocker 11 of the go-to-market review). "Try 14 Days Free" stood alone:
 * nothing said what is charged afterwards, how often, or how to stop it,
 * which automatic-renewal laws (California's ARL among them) and the FTC
 * expect to see before the buyer agrees.
 */
export const RenewalTerms: React.FC<Props> = ({ price, kind, className }) => {
  const { t } = useI18nStore();
  return (
    <p className={`text-xs leading-snug text-gray-500 ${className ?? ""}`}>
      {(kind === "recurring" ? t.renewTermsMonthly : t.renewTermsTrip).replace(
        "{price}",
        price,
      )}
    </p>
  );
};
